import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-visibility"
export default class extends Controller {
  static targets = ["input", "icon", "button"]

  static values = {
    revealed: { type: Boolean, default: false }
  }

  connect() {
    this.update()
  }

  toggle(event) {
    event.preventDefault()
    this.revealedValue = !this.revealedValue
    this.update()
  }

  update() {
    if (this.hasInputTarget) {
      this.inputTarget.type = this.revealedValue ? "text" : "password"
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-eye", !this.revealedValue)
      this.iconTarget.classList.toggle("fa-eye-slash", this.revealedValue)
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-pressed", this.revealedValue.toString())
    }
  }
}
